import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Title } from '../layout';

class ProgramListComponent extends Component {
  render() {
    const { match, programEnrollment } = this.props;
    const { params } = match;
    const { siteId, programId } = params;

    var programFound = true;
    var site, program;
    if(siteId === null || programId === null){
      programFound = false;
    } else {
      site = programEnrollment.enrollment.sites.find(s => s.siteId === siteId);
      if (!site){
        programFound = false;
      } else{
        program = site.programs.find(p => p.programId === programId);
      }
    }

    return (
      <div>
        <Title title="Program"/>
        { programFound && program ? (
            <div>
              <h1 className="page-header">
                { !program.alias ? program.name : program.alias }
              </h1>
              <p>
                Program information goes here.
              </p>
            </div>
          ) : (
            <div className="alert alert-danger">
              Program Not Found
            </div>
          )
        }
      </div>
    );
  }
}

ProgramListComponent.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = ({ auth, programEnrollment }) => {
  return {
    auth,
    programEnrollment
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramListComponent);



// WEBPACK FOOTER //
// src/programs/program-list.component.js